import { randomSession } from 'common/utils';

type ResourceTypeProp = 'VIDEO' | 'DOC' | 'AUDIO' | 'IMAGE' | 'ANIMATION';
type UsageTypeProp = 'template'; // 模版中上传音频特殊处理

export const resourceUploadByFetch = (
  file: Blob,
  type: ResourceTypeProp,
  usage?: UsageTypeProp
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('sessionId', randomSession());
  formData.append('type', type);
  formData.append('subject', alo7Nav.subject);

  return alo7Api.fetch(
    `${alo7Api.prefix.host}/api/v1/resources_${(usage === 'template' &&
      'english') ||
      alo7Nav.subject}`,
    {
      method: 'POST',
      body: formData,
      headers: { 'Content-Type': 'auto' },
    }
  );
};
